// ═══════════════════════════════════════════════════════════════════════════
// PUBBLICAZIONE DEI GIORNI NELLA PROGRAMMAZIONE (ottobre 2026)
// ═══════════════════════════════════════════════════════════════════════════
// Ogni giorno ha un quadratino in testa alla colonna: spuntato = visibile a chi non
// programma (commesse e automezzi), tolto = privato. Decisione di Paolo: i giorni NUOVI
// devono partire PRIVATI e diventare visibili solo quando chi programma li spunta.
//
// Per non nascondere di colpo programmi già in uso, la regola vale dai giorni a partire da
// una data di decorrenza (programmazioniPrivacy.giorniPrivatiDal), fissata la prima volta
// al lunedì successivo: la settimana in corso resta com'era. I giorni prima di quella data
// senza una scelta esplicita restano pubblicati, come prima.
// L'impostazione si può spegnere da 🔒 Privacy (giorniNuoviPrivati: false).
// ═══════════════════════════════════════════════════════════════════════════

/** true se il giorno è visibile a chi non programma. */
export function giornoPubblicato(mappaPubblicati, dateStr, privacy) {
  const v = mappaPubblicati?.[dateStr];
  if (v === true) return true;
  if (v === false) return false;
  const dal = privacy?.giorniPrivatiDal;
  if (privacy?.giorniNuoviPrivati !== false && dal && dateStr >= dal) return false;
  return true;
}

/** Lunedì successivo a una data, come "YYYY-MM-DD" (decorrenza della regola). */
export function lunediSuccessivo(da = new Date()) {
  const d = new Date(da.getFullYear(), da.getMonth(), da.getDate());
  const g = d.getDay();
  d.setDate(d.getDate() + (g === 0 ? 1 : 8 - g));
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
